module.exports = __webpack_public_path__ + "static/media/kenzie-burguer.e8ae8916.png";